export { default } from "./LessonOverviewCommonMisconceptions";
export type { LessonOverviewCommonMisconception } from "./LessonOverviewCommonMisconceptions";
